import React from "react";
import NewFileBox from "./NewFileBox";
import FileUpload from "./FileUpload";
import FormContext from "../support/FormContext";
import OldFileBox from "./OldFileBox";
import ChangeCheckContext from "../support/ChangeCheckContext";
import PhotoEditor from "./PhotoEditor";

function MultiFileInput(props) {
    // const {data} = React.useContext(FormContext);

    const {disable} = React.useContext(ChangeCheckContext)
    const [photoEditorData, setPhotoEditorData] = React.useState(null)

    function newFilesUpload(files, fileData) {
        let newFiles = [...fileData];
        let pendingReads = files.length;

        files.forEach((file) => {
            const newFileData = {newFile: true, file: file, print: false, image: ""};

            if (newFileData.file && newFileData.file.type.match('image.*')) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    newFileData.image = e.target.result
                    newFileData.print = true;
                    newFiles.push(newFileData);
                    pendingReads -= 1;

                    // When all pending reads are complete, update the state.
                    if (pendingReads === 0) {
                        finalizeUpload(newFiles);
                    }
                };
                reader.readAsDataURL(newFileData.file);
            } else {
                newFiles.push(newFileData);
                pendingReads -= 1;

                // When all pending reads are complete, update the state.
                if (pendingReads === 0) {
                    finalizeUpload(newFiles);
                }
            }
        });
    }

    function finalizeUpload(newFiles) {
        props.setFileData(newFiles);
    }

    function deleteAttachment(index) {
        let newFiles = [...props.fileData]
        newFiles.splice(index, 1)
        props.setFileData(newFiles)
    }

    function editImage(index) {
        let imageSource = props.fileData[index].file
        const image = new window.Image();
        if (props.fileData[index].newFile === false) {
            fetch(imageSource)
                .then(response => response.blob())
                .then(blob => {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        image.onload = () => setPhotoEditorData({ image: image, index: index });
                        image.src = e.target.result; // This is the data URL
                    };
                    reader.readAsDataURL(blob);
                })
                .catch(error => console.error('Error fetching the image:', error));
        } else {
            const reader = new FileReader();
            reader.onload = (e) => {
                image.onload = () => setPhotoEditorData({image: image, index: index});
                image.src = e.target.result;  // This is the data URL
            };
            reader.readAsDataURL(imageSource)
        }
    }

    function updateImage(index, file, image) {
        let newFiles = [...props.fileData]
        newFiles[index].file = file
        newFiles[index].image = image
        if (newFiles[index].hasOwnProperty('id')) {
            delete newFiles[index].id;
        }
        newFiles[index].newFile = true
        props.setFileData(newFiles)
        setPhotoEditorData(null)
    }

    React.useEffect(() => {
        if (props.fileData.length === 0) {
            let files = []
            props.data.Prilohy.forEach((file) => {
                const oldFile = {newFile: false, file: file.Link, print: file.Tlacit, image: "", id: file.id}
                files.push(oldFile)
            })
            props.setFileData(files)
        }
    }, [props.data]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            <div disabled={disable} className="mb-3 mt-3">
                <FileUpload newFilesUpload={newFilesUpload}
                            fileData={props.fileData}/>
            </div>
            <table className="table table-bordered" id="fileUploadTable">
                <thead className="table-dark table-header">
                <tr>
                    <th scope="col">Náhľad</th>
                    <th scope="col">Súbor</th>
                    <th scope="col"colSpan="2">Akcie</th>
                </tr>
                </thead>
                <tbody>
                {props.fileData.map((fileData, ndx) => (
                    fileData.newFile === true ?
                        <NewFileBox key={ndx}
                                    src={fileData['image']}
                                    ndx={ndx}
                                    file={fileData.file}
                                    print={fileData.print}
                                    onChange={props.onChange}
                                    delete={deleteAttachment}
                                    editImage={editImage}
                        /> :
                        <OldFileBox key={ndx}
                                    link={fileData.file}
                                    print={fileData.print}
                                    delete={deleteAttachment}
                                    editImage={editImage}
                                    ndx={ndx}
                                    onChange={props.onChange}/>
                ))}
                </tbody>
            </table>
            {photoEditorData && <PhotoEditor data={photoEditorData} updateImage={updateImage}/>}
        </>
    )
}

export default MultiFileInput
